<template>
  <div class="front-layout">
    <div class="main-content">
      <div class="top-fixed-area">
        <div class="search-bar" style="position: relative; width: 600px">
          <el-input
            placeholder="搜索"
            style="width: 600px"
            v-model="searchKeyword"
          ></el-input>
          <img
            @click="handleSearchClick"
            style="
              width: 25px;
              height: 29px;
              position: absolute;
              right: 0;
              bottom: 1px;
              cursor: pointer;
            "
            :src="imgurl"
            alt=""
          />
        </div>

        <div class="top-nav">
          <el-menu
            mode="horizontal"
            text-color="#333"
            active-text-color="#C1272D"
            :default-active="activeCategoryId"
            @select="handleCategoryChange"
          >
            <el-menu-item key="" index=""> 推荐 </el-menu-item>

            <el-menu-item
              v-for="category in fllist"
              :key="category.id"
              :index="category.id.toString()"
            >
              {{ category.name }}
            </el-menu-item>
          </el-menu>
        </div>
      </div>

      <!-- ★ 滚动容器加了 ref="scrollWrap"，用于恢复滚动位置 -->
      <div
        class="product-scroll-wrapper"
        ref="scrollWrap"
        @scroll="handleScroll"
      >
        <div class="product-list" ref="productListWrap">
          <div v-if="productList.length === 0 && !loading" class="no-product">
            暂无匹配商品~
          </div>

          <!-- 加载状态 -->
          <div v-if="loading && currentPage === 1" class="loading-box"></div>

          <!-- 商品项 -->
          <div
            class="product-item"
            v-for="item in productList"
            :key="item.id"
            @click="tz(item.id)"
          >
            <!-- 商品容器 -->
            <div class="product-img-wrapper">
              <el-image
                :src="item.coverUrl"
                fit="cover"
                @load="onImageLoaded"
              ></el-image>

              <div class="product-tags" v-if="item.belongName == '官方发布'">
                <span class="product-tag" @click="tz(item.id)">面料供应</span>
                <span class="product-tag" @click="tz(item.id)">辅料供应</span>
              </div>
            </div>

            <div class="product-bottom-text">
              <el-tooltip
                effect="dark"
                :content="`\n${item.title}`"
                placement="top"
                popper-append-to-body
                ><span>{{ item.title }}</span>
              </el-tooltip>
            </div>

            <div class="product-action-bar">
              <span class="view-btn"> {{ item.belongName }}</span>
              <el-button
                type="text"
                class="view-btn"
                @click.stop="tz(item.id, '色卡')"
                >查看色卡</el-button
              >
            </div>
          </div>

          <div v-if="loading && currentPage > 1" class="load-more">
            正在加载更多...
          </div>
        </div>
      </div>
    </div>

    <!-- 商品详情弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      width="70%"
      top="5vh"
      :before-close="closeDialog"
      class="product-detail-dialog"
    >
      <div class="dialog-container" v-if="Object.keys(detailData).length">
        <!-- 左侧图片区域-->
        <div class="dialog-left">
          <div class="img-wrap">
            <el-carousel
              v-if="sklist.length > 0"
              height="100%"
              indicator-position="outside"
              :initial-index="indexs"
            >
              <el-carousel-item v-for="(img, index) in sklist" :key="img.url">
                <el-image
                  :src="getFullImgUrl(img.url)"
                  fit="contain"
                  style="
                    width: 100%;
                    height: 100%;
                    display: block;
                    cursor: zoom-in;
                  "
                  @click="openImgViewer(index)"
                ></el-image>
              </el-carousel-item>
            </el-carousel>
            <div v-else class="empty-img">暂无产品图</div>
          </div>
        </div>

        <!-- 右侧信息区域 完全不变 -->
        <div class="dialog-right">
          <div class="author-header">
            <div class="avatar">
              <el-image
                :src="getFullImgUrl(detailData.belongAvatarUrl)"
                fit="cover"
                circle
                style="width: 48px; height: 48px"
              ></el-image>
            </div>
            <span class="author-name">{{ detailData.belongName }}</span>
            <el-button
              :disabled="detailData.source == 1"
              @click="
                aa(
                  detailData.belongId,
                  detailData.memberFollowStatus,
                  detailData.id
                )
              "
              class="follow-btn"
              type="danger"
              >{{
                detailData.memberFollowStatus == 0 ? "关注" : "已关注"
              }}</el-button
            >
          </div>
          <!-- 产品信息 -->
          <div class="info-block">
            <h6 class="block-title">面料信息：</h6>
            <div class="info-row" style="display: flex">
              <p class="label">品名/编号:</p>
              <p class="val" style="margin-right: 35px">
                {{ detailData.name }}
              </p>
              <p class="label">幅宽:</p>
              <p class="val" style="margin-right: 35px">
                {{ detailData.width }}
              </p>
              <p class="label">克量:</p>
              <p class="val">{{ detailData.weight }}</p>
            </div>

            <div class="info-row">
              <span
                class="label"
                style="width: 32px !important; display: inline-block"
                >成份:</span
              >

              <span class="val">{{ detailData.ingredients }}</span>
            </div>
          </div>
          <div class="product-titles">
            <el-tooltip
              effect="dark"
              :content="detailData.title"
              placement="top"
              popper-append-to-body
            >
              <span>{{ detailData.title }}</span>
            </el-tooltip>
          </div>
          <!-- 产品标题 -->
          <div class="product-title">
            <el-tooltip
              effect="dark"
              :content="detailData.content"
              placement="top"
              popper-append-to-body
            >
              <span>{{ detailData.content }}</span>
            </el-tooltip>
          </div>
          <div class="supply-tags" v-if="detailData.source == 1">
            <!-- 面料供应模块 -->
            <div class="supply-block">
              <div class="supply-tag title-tag">面料供应</div>
              <div class="supply-account-list">
                <span
                  class="account-item"
                  v-for="item in detailData.fabricSupplierList"
                  :key="item.id"
                  @click="goSupplier(1)"
                >
                  {{ item.nickName }}
                </span>
              </div>
            </div>

            <!-- 辅料供应模块 -->
            <div class="supply-block">
              <div class="supply-tag title-tag">辅料供应</div>
              <div class="supply-account-list">
                <span
                  class="account-item"
                  v-for="item in detailData.accessorySupplierList"
                  :key="item.id"
                  @click="goSupplier(2)"
                >
                  {{ item.nickName }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-image-viewer
        v-if="imgViewerVisible"
        :url-list="imgViewerList"
        :initial-index="imgViewerIndex"
        @close="closeImgViewer"
      />
    </el-dialog>
  </div>
</template>

<script>
import Masonry from "masonry-layout";
import srcs from "../front/lalian.png";

export default {
  name: "FrontProductList", //要和 keep-alive 的 include 要和这个 name一样
  data() {
    return {
      indexs: 0, //决定轮播图从哪里播的索引
      imgurl: srcs,
      activeCategoryId: "", //默认选中推荐
      searchKeyword: "",
      fllist: [], // 分类列表
      productList: [], // 商品数据

      savedScrollTop: 0, // 记住滚动位置（切走页面再回来恢复）

      masonry: null,
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      hasMore: true,

      // 商品弹窗
      dialogVisible: false,
      detailData: {},

      // 图片全屏预览
      imgViewerVisible: false,
      imgViewerList: [],
      imgViewerIndex: 0,
      sklist: [],

      spid: "",
    };
  },
  mounted() {
    // 获取分类
    this.getCategoryList();
    window.addEventListener("resize", () => {
      this.$nextTick(() => this.refreshMasonry());
    });
  },
  // keep-alive 页面激活时触发
  activated() {
    this.$nextTick(() => {
      const wrap = this.$refs.scrollWrap;
      if (wrap && this.savedScrollTop > 0) {
        wrap.scrollTop = this.savedScrollTop;
      }
      this.refreshMasonry();
    });
  },
  beforeUnmount() {
    if (this.masonry) this.masonry.destroy();
    window.removeEventListener("resize", () => {
      this.$nextTick(() => this.refreshMasonry());
    });
  },
  watch: {
    productList: {
      handler() {
        this.$nextTick(() => this.initMasonry());
      },
      deep: true,
    },
  },
  methods: {
    //跳转供应商
    goSupplier(num) {
      console.log("要跳转的供应商id：", this.cpid, num);
      this.$router.push({
        path: "/home",
        query: { supplierId: this.cpid, num: num },
      });
    },

    mianget() {
      console.log("这是面料供应");
    },
    fuget() {
      console.log("这是辅料供应");
    },
    async aa(id, foll, cpid) {
      console.log("saass", id);
      const sendata = {
        memberId: id, //用户id
        followStatus: foll == 0 ? 1 : 0, //0未关注 1已关注
      };
      const res = await this.$api.shouye.gz(sendata);
      this.tzs(cpid);
      console.log(res);
    },
    getFullImgUrl(url) {
      if (!url) return "";

      if (/^https?:\/\//.test(url)) {
        return url;
      }

      return `https://${url}`;
    },

    initMasonry() {
      const wrap = this.$refs.productListWrap;
      if (!wrap) return;

      // ★ 布局前后保住滚动位置，防止浏览器把 scrollTop 收回去
      const scrollWrap = this.$refs.scrollWrap;
      const savedTop = scrollWrap ? scrollWrap.scrollTop : 0;

      if (this.masonry) {
        // ★★★ 关键修复：已有实例时不要 destroy + 重建！
        // destroy() 会移除所有卡片的绝对定位，列表瞬间塌成一列、
        // 容器高度骤降，浏览器把 scrollTop 强行收回顶部——这就是
        // "加载下一页时闪到初始位置再闪回来"的原因。
        // 改成重新收集条目 + 重新布局即可，高度不塌、位置不丢。
        this.masonry.reloadItems();
        this.masonry.layout();
      } else {
        this.masonry = new Masonry(".product-list", {
          itemSelector: ".product-item",
          columnWidth: 241,
          gutter: 90,
          percentPosition: false,
          transitionDuration: "0",
        });
      }

      // ★ 布局完成后把滚动位置放回去（重置列表时 savedTop 已是 0，不受影响）
      this.$nextTick(() => {
        if (scrollWrap) scrollWrap.scrollTop = savedTop;
      });
    },

    refreshMasonry() {
      if (!this.masonry) return;
      this.$nextTick(() => {
        this.masonry.reloadItems();
        this.masonry.layout();
      });
    },

    onImageLoaded() {
      this.refreshMasonry();
    },

    handleScroll(e) {
      const scrollDom = e.target;
      const { scrollTop, scrollHeight, clientHeight } = scrollDom;

      // ★ 实时记住滚动位置，切走页面再回来就恢复到这里（小红书效果）
      this.savedScrollTop = scrollTop;

      // 距离底部200px触发分页
      const isBottom = scrollTop + clientHeight >= scrollHeight - 200;
      if (isBottom && !this.loading && this.hasMore) {
        this.currentPage++;
        this.loadProductList(false);
      }
    },

    // 1. 获取分类
    async getCategoryList() {
      try {
        const res = await this.$api.shouye.getfl();
        if (res.data?.code === "200") {
          this.fllist = res.data.data.list;
          // 加载推荐商品（categoryId为空）
          this.loadProductList(true);
        } else {
          console.log("获取分类列表失败：", res.data?.msg || "接口返回异常");
        }
      } catch (error) {
        console.error("获取分类列表请求异常：", error);
      }
    },

    // 2. 商品
    async pro(sendata, isReset) {
      this.loading = true;
      try {
        const res = await this.$api.shouye.get(sendata);
        if (res.data?.code === "200") {
          const { list, total } = res.data.data;
          this.total = total;
          // 拼接图片地址
          const formatList = list.map((item) => ({
            ...item,
            coverUrl: item.coverUrl?.startsWith("https")
              ? item.coverUrl
              : `https://${item.coverUrl}`,
          }));

          if (isReset) {
            this.productList = formatList;
            // ★ 重置列表（切分类/搜索/刷新）时，滚动位置也要归零
            this.savedScrollTop = 0;
            const wrap = this.$refs.scrollWrap;
            if (wrap) wrap.scrollTop = 0;
          } else {
            this.productList = [...this.productList, ...formatList];
          }

          this.hasMore = this.productList.length < this.total;
        } else {
          console.log("获取商品列表失败：", res.data?.msg || "接口返回异常");
        }
      } catch (error) {
        console.error("获取商品列表请求异常：", error);
      } finally {
        this.loading = false;
        this.refreshMasonry();
      }
    },

    async loadProductList(isReset = true) {
      if (isReset) {
        this.currentPage = 1;
      }
      const requestParams = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        categoryId: this.activeCategoryId,
        complexSearch: this.searchKeyword.trim(),
      };
      console.log("商品接口请求参数：", requestParams);
      this.pro(requestParams, isReset);
    },

    // 4. 打开弹窗
    async tz(id, seka) {
      this.cpid = "";
      this.cpid = id;
      if (seka == "色卡") {
        this.sklist = [];
        const sendata = {
          productId: id, //产品id
        };
        console.log("商品ID：", id);
        const res = await this.$api.shouye.add(sendata);

        if (res.data.code == "200") {
          this.detailData = res.data.data;
          this.dialogVisible = true;
          this.sklist.push({ url: res.data.data.coverUrl });
          for (
            let index = 0;
            index < res.data.data.particularsList.length;
            index++
          ) {
            this.sklist.push({ url: res.data.data.particularsList[index].url });
          }
          for (
            let index = 0;
            index < res.data.data.colorcardList.length;
            index++
          ) {
            this.sklist.push({ url: res.data.data.colorcardList[index].url });
          }
          this.indexs = res.data.data.particularsList.length + 1;
          console.log(this.sklist, this.indexs, "包含了什么色卡图集");
        }
      } else {
        this.sklist = [];
        const sendata = {
          productId: id, //产品id
        };
        console.log("商品ID：", id);
        const res = await this.$api.shouye.add(sendata);
        if (res.data.code == "200") {
          this.detailData = res.data.data;
          this.dialogVisible = true;
          this.sklist.push({ url: res.data.data.coverUrl });
          for (
            let index = 0;
            index < res.data.data.particularsList.length;
            index++
          ) {
            this.sklist.push({ url: res.data.data.particularsList[index].url });
          }
          for (
            let index = 0;
            index < res.data.data.colorcardList.length;
            index++
          ) {
            this.sklist.push({ url: res.data.data.colorcardList[index].url });
          }
          this.indexs = 1;
          console.log(this.sklist, this.indexs, "包含了什么色卡图集");
        }
      }
    },
    async tzs(id) {
      const sendata = {
        productId: id, //产品id
      };
      const res = await this.$api.shouye.add(sendata);
      if (res.data.code == "200") {
        this.detailData = res.data.data;
      }
    },

    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.detailData = {};
      this.imgViewerVisible = false;
      this.imgViewerList = [];
      this.imgViewerIndex = 0;
    },

    // 打开全屏图片预览
    openImgViewer(index) {
      this.imgViewerList = this.sklist.map((item) =>
        this.getFullImgUrl(item.url)
      );
      this.imgViewerIndex = index;
      this.imgViewerVisible = true;
    },
    // 关闭图片预览
    closeImgViewer() {
      this.imgViewerVisible = false;
    },

    // 5. 分类切换
    handleCategoryChange(categoryId) {
      this.activeCategoryId = categoryId;
      this.loadProductList(true);
    },

    // 6. 搜索出发
    handleSearchClick() {
      console.log("我出发了吗");

      this.loadProductList(true);
    },
  },
};
</script>

<style scoped lang="less">
::v-deep html,
::v-deep body {
  margin: 0;
  overflow-y: hidden !important;
}
.el-carousel--horizontal {
  overflow-x: visible !important;
}
::v-deep .el-image-viewer__close {
  right: 146px !important;
}
.el-menu--horizontal > .el-menu-item {
  line-height: 40px;

  height: 40px;
}

.front-layout {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;

  .main-content {
    flex: 1;
    width: 100%;
    max-width: 1791px;
    margin: 0 auto;
    padding: 0 20px;
    height: 100vh;
    box-sizing: border-box;

    .top-fixed-area {
      position: absolute;
      top: 0;
      left: 0;
      right: 20px;
      z-index: 10;
      padding: 20px 0;
      background-color: #fff;

      .search-bar {
        margin-bottom: 20px;
      }

      .top-nav {
        margin-bottom: 0;
        .el-menu {
          border-bottom: none;
        }
      }
    }

    .product-scroll-wrapper {
      position: absolute;
      top: 163px;
      left: 0;
      right: 20px;
      bottom: 0;
      overflow-y: auto;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;

      .product-list {
        padding: 10px 0;
        position: relative;

        .no-product {
          width: 100%;
          text-align: center;
          padding: 50px 0;
          color: #999;
          font-size: 16px;
        }
        .loading-box,
        .load-more,
        .no-more {
          width: 100%;
          text-align: center;
          padding: 20px 0;
          color: #999;
        }

        .product-item {
          width: 241px;
          position: relative;
          cursor: pointer;
          box-sizing: border-box;

          .product-img-wrapper {
            position: relative;
            margin-bottom: 0;
            background: #f5f5f5;
            border-radius: 12px 12px 0 0;
            padding: 0;
            height: 313px;
            box-shadow: none;
            transition: none;
            overflow: hidden;

            .el-image {
              width: 100% !important;
              height: 100% !important;
            }

            .product-tags {
              position: absolute;
              right: 10px;
              bottom: 10px;
              display: flex;
              flex-direction: column;
              gap: 8px;
              z-index: 1;

              .product-tag {
                background: #fff;
                color: #666;
                padding: 4px 12px;
                border-radius: 4px;
                font-size: 12px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              }
            }
          }

          .product-bottom-text {
            background: #fff;
            padding: 19px 10px;
            height: 56px;
            box-sizing: border-box;
            font-size: 14px;
            color: #333;
            line-height: 1.4;
            text-align: center;
            white-space: pre-line;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 0;
          }

          .product-action-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            border-top: none;

            .view-btn {
              color: #333;
              font-family: "微软雅黑 Light", "微软雅黑", Avenir, Helvetica,
                Arial, sans-serif;
              font-size: 14px;
              padding: 0;
              &:hover {
                color: #c1272d;
              }
            }
          }
        }
      }
    }
  }

  ::v-deep .product-detail-dialog {
    .el-dialog__body {
      padding: 0 !important;
    }
    .el-carousel__container {
      padding: 0 !important;
    }
    .el-carousel__indicators--outside {
      padding-bottom: 20px;
    }
  }

  .dialog-container {
    display: flex;
    width: 100%;
    height: 80vh;
    overflow: hidden;

    .dialog-left {
      overflow: hidden;
      width: 57%;
      background: #ffffff;
      .img-wrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .el-carousel {
          flex: 1;
          width: 100%;
          padding: 0;
        }
        .empty-img {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #999;
          font-size: 16px;
        }
      }
    }

    .dialog-right {
      width: 43%;
      padding: 30px;
      padding-top: 0;
      overflow-y: auto;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 2px;
      }

      .author-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 30px;
        .avatar {
          flex-shrink: 0;
        }
        .author-name {
          font-size: 18px;
          font-weight: 500;
          flex: 1;
        }
        .follow-btn {
          background: #c1272d;
          border: none;
          padding: 6px 18px;
          color: #fff;
        }
      }

      .info-block {
        margin-bottom: 24px;
        .block-title {
          font-size: 16px;
          color: #333;
          font-weight: 700;
          margin-bottom: 16px;
          font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei",
            sans-serif;
        }
        .info-row {
          font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
          margin-bottom: 12px;
          font-size: 13px;
          font-weight: 300; /* Light细体 */

          .label {
            text-align: left;
            color: #333;
            font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
            font-size: 13px;
            font-weight: 300; /* Light细体 */
            display: inline-block;
          }
          .val {
            color: #666;
          }
          &.two-col {
            display: flex;
            gap: 40px;
            .col {
              flex: 1;
            }
          }
        }
      }
      .product-title {
        font-size: 16px;
        font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
        line-height: 1.5;
        margin-bottom: 16px;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .product-titles {
        font-size: 16px;
        font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
        line-height: 1.5;
        margin-bottom: 16px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .supply-tags {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 24px;
        .supply-tag {
          background: #fff9cc;
          font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
          font-weight: 300; /* Light细体 */
          padding: 8px 12px;
          font-size: 16px;
          color: #333;
        }
      }

      .detail-content {
        line-height: 1.8;
        font-size: 15px;
        color: #444;
        h2 {
          margin: 16px 0 8px;
        }
        strong {
          color: #000;
        }
      }
    }
  }
}

// 响应式布局
@media (max-width: 768px) {
  .front-layout .main-content {
    padding: 0 10px;

    .top-fixed-area {
      left: 10px;
      right: 10px;
      .search-bar .el-input {
        width: 100% !important;
      }
    }

    .product-scroll-wrapper {
      top: 130px;
      left: 10px;
      right: 10px;
      .product-list {
        .product-item {
          width: 160px;
          box-sizing: border-box;
          .product-img-wrapper {
            height: 208px;
            padding: 0;
          }
          .product-bottom-text {
            height: 48px;
            padding: 10px 8px;
            font-size: 12px;
          }
          .product-action-bar {
            padding-top: 8px;
            .view-btn {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  ::v-deep .product-detail-dialog {
    width: 98% !important;
  }
  .dialog-container {
    flex-direction: column !important;
    height: auto !important;
    .dialog-left,
    .dialog-right {
      width: 100% !important;
    }
    .dialog-left {
      height: 50vh;
    }
    .dialog-right {
      height: auto;
      max-height: 60vh;
    }
  }
}
.supply-block {
  margin-bottom: 16px;
}
.supply-tag.title-tag {
  margin-bottom: 8px;
}
.supply-account-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  .account-item {
    font-size: 14px;
    color: #e68a00;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
